var _effectorFileName = "/src/page-content/home/components/main/main.tsx";
import { useState } from 'react';
import Image from 'next/image';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { ContactModal } from '@/shared/components/contact-modal';
import { NumberTicker } from '@/shared/components/number-ticker';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const Main = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const textClasses = cn('text-2xl sm:text-4xl lg:text-5xl !leading-[115%] font-medium tracking-tight max-w-6xl xl:max-w-none');
  const gradientClasses = cn('text-balance bg-gradient-to-br from-black/85 from-30% to-black/60 bg-clip-text text-transparent', 'dark:from-white dark:to-white/40');
  const highlightWrapperClasses = cn('relative inline-block bg-brand-accent-superLight px-3 py-0.5 z-0',
  // Left vertical line with synchronized cursor blink animation
  'before:content-[""]', 'before:absolute', 'before:top-0', 'before:bottom-0', 'before:-left-0', 'before:w-0.5', 'before:rounded-full', 'before:bg-brand-accent-normal', 'before:dark:bg-brand-accent-normal', 'before:z-10', 'before:animate-blink',
  // Right vertical line with synchronized cursor blink animation
  'after:content-[""]', 'after:absolute', 'after:top-0', 'after:bottom-0', 'after:-right-0.5', 'after:w-0.5', 'after:rounded-full', 'after:bg-brand-accent-normal', 'after:dark:bg-brand-accent-normal', 'after:z-10', 'after:animate-blink');

  // Classes for circles above lines
  const circleLeftClasses = cn('absolute top-0 left-0 -translate-y-[90%] translate-x-[10%]', 'w-3 h-3', 'bg-brand-accent-normal dark:bg-brand-accent-normal', 'rounded-full', 'z-20', 'animate-blink');
  const circleRightClasses = cn('absolute bottom-0 translate-y-[90%] right-0 translate-x-[10%]', 'w-3 h-3', 'bg-brand-accent-normal dark:bg-brand-accent-normal', 'rounded-full', 'z-20', 'animate-blink');
  return <>
      <main className="relative flex h-screen items-end justify-center pt-[73px] md:max-h-[1024px] md:min-h-full 2xl:min-h-[70vh]">
        <div className="absolute inset-0 bg-[url('/images/bg-emoji.png')] bg-contain bg-center opacity-40 lg:bg-no-repeat" />

        <div className="absolute inset-0 left-0 top-[15%] z-0">
          <Image src="/images/common/main-2.webp" alt={`Профессиональный английский для работы и жизни в ${APP_TITLE}`} fill className={cn('select-none object-contain transition-opacity duration-500', imageLoaded ? 'opacity-100' : 'opacity-0')} loading="lazy" sizes="100vw" draggable={false} onLoad={() => setImageLoaded(true)} />

          <GradientBg className="z-0 hidden animate-fade-in-glow sm:block" type="circle" origin="center" size={300} />
        </div>

        {/* Content */}
        <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center justify-center bg-background/95 px-6 py-8 text-center backdrop-blur supports-[backdrop-filter]:bg-background/60 sm:px-12 md:max-w-none">
          <h1 className={cn(textClasses, gradientClasses)}>
            <span className={highlightWrapperClasses}>
              {/* Circle above left line */}
              <span className={cn(circleLeftClasses, '-left-1.5')} />
              {/* Text with gradient */}
              <span className="relative z-10 bg-gradient-to-br from-black/85 from-30% to-black/60 bg-clip-text text-transparent">
                Английский
              </span>
              {/* Circle below right line */}
              <span className={cn(circleRightClasses, '-right-1.5')} />
            </span>
            &nbsp;под вашу цель
          </h1>

          <p className="mt-4 max-w-2xl text-center text-sm text-gray-700 dark:text-white sm:mt-6 md:text-base">
            Подготовим к&nbsp;собеседованию, IELTS или работе за&nbsp;рубежом. Составим персональный план и&nbsp;будем
            отслеживать прогресс после каждого занятия.
          </p>

          <ContactModal entryPoint="INDIVIDUAL_PAGE">
            <Button variant="cta" size="lg" className="mt-4 hidden px-6 sm:mt-6 sm:block" aria-label="Записаться на бесплатную консультацию">
              Свяжитесь со мной
            </Button>
          </ContactModal>

          <div className="mt-6 flex items-center justify-center gap-8 border-b border-gray-200 px-4 pb-4 dark:border-gray-500 md:mt-10">
            <div className="flex flex-col items-center border-r border-gray-200 pr-8 dark:border-gray-500 sm:items-start">
              <div className="flex items-center gap-1 text-base sm:text-lg">
                &gt;&nbsp;
                <NumberTicker className="inline text-lg font-medium sm:text-2xl" value={700} />
              </div>

              <p className="mt-1 text-xs sm:text-sm">Довольных студентов</p>
            </div>

            <div className="flex flex-col items-center sm:items-start">
              <div className="flex items-center gap-1 text-base sm:text-lg">
                &gt;&nbsp;
                <NumberTicker className="inline text-lg font-medium sm:text-2xl" value={8000} />
              </div>

              <p className="mt-1 text-xs sm:text-sm">Часов английского</p>
            </div>
          </div>
        </div>
      </main>
    </>;
};